import {
  InstructorRemovalOutcome,
  InstructorRemovalReason,
  InstructorRemovalSnapshot,
} from "./types";

export const getInstructorCorrectionValidity = (
  snapshot: Pick<InstructorRemovalSnapshot, "instructors">,
) => {
  const responsibilityTotal = snapshot.instructors.reduce(
    (total, instructor) => total + instructor.responsibility,
    0,
  );
  const primaryCount = snapshot.instructors.filter(instructor => instructor.isPrimary).length;

  return {
    responsibilityTotal,
    primaryCount,
    responsibilityValid: responsibilityTotal === 100,
    primaryValid: primaryCount === 1,
    valid: snapshot.instructors.length > 0 && responsibilityTotal === 100 && primaryCount === 1,
  };
};

export const classifyInstructorRemoval = (
  before: InstructorRemovalSnapshot,
  after: InstructorRemovalSnapshot,
  pendingReplacement = false,
): InstructorRemovalOutcome => {
  const remainingIds = new Set(after.instructors.map(instructor => instructor.instructorId));
  const removed = before.instructors.filter(
    instructor => !remainingIds.has(instructor.instructorId),
  );
  const validity = getInstructorCorrectionValidity(after);
  const reasons: InstructorRemovalReason[] = [];

  const responsibilityWasAffected = removed.some(instructor => instructor.responsibility > 0);
  const primaryWasAffected = removed.some(instructor => instructor.isPrimary);

  if ((pendingReplacement || responsibilityWasAffected) && !validity.responsibilityValid) {
    reasons.push("responsibility");
  }

  if ((pendingReplacement || primaryWasAffected) && !validity.primaryValid) {
    reasons.push(validity.primaryCount > 1 ? "primary-multiple" : "primary-missing");
  }

  return {
    reasons,
    hasNoInstructors: after.instructors.length === 0,
  };
};
